// // src/components/Login.js
// import React, { useState, useContext, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';
// import { Link } from 'react-router-dom';

// axios.defaults.withCredentials = true; // Ensure cookies are sent with all requests

// function Login() {
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//   });
//   const [error, setError] = useState('');
//   const { isAuthenticated, setIsAuthenticated, setUser } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const { email, password } = formData;

//   const onChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });



//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     try {
//       const response = await axios.post('/auth/login', formData, {
//         withCredentials: true,
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       });
      
//       if (response.data.user) {
//         setUser(response.data.user);
//         setIsAuthenticated(true);
//         navigate('/dashboard');
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Login failed. Please try again.');
//     }
//   };





//   useEffect(() => {
//     if (isAuthenticated) {
//       navigate('/dashboard');
//     }
//   }, [isAuthenticated, navigate]);

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gray-50">
//       <form onSubmit={onSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">
//         <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
//         {error && (
//           <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
//             {error}
//           </div>
//         )}
//         <input
//           type="email"
//           placeholder="Email"
//           name="email"
//           value={email}
//           onChange={onChange}
//           required
//           className="w-full p-3 mb-4 border rounded"
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           name="password"
//           value={password}
//           onChange={onChange}
//           required
//           className="w-full p-3 mb-6 border rounded"
//         />
//         <button 
//           type="submit" 
//           className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700 transition"
//         >
//           Login
//         </button>
//         <p className="mt-4 text-center">
//           Don't have an account? <Link to="/register" className="text-blue-600 hover:underline">Register here</Link>
//         </p>
//         <p className="mt-4 text-center">
//           <a
//             href="mailto:support@mdorbit.com?subject=Password%20Reset%20Request"
//             className="text-blue-600 hover:underline"
//           >
//             Forgot Password?
//           </a>
//         </p>
//       </form>
//     </div>
//   );
// }

// export default Login;

// src/components/Login.js
import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

axios.defaults.withCredentials = true;

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const { isAuthenticated, setIsAuthenticated, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { email, password } = formData;

  useEffect(() => {
    // Check for success message from password reset
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      // Clear the message from location state
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    try {
      // const response = await axios.post('/auth/login', formData, {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
        ...formData,
        email: String(formData.email).trim().toLowerCase()
        }, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          }
      });
      
      if (response.data.user) {
        setUser(response.data.user);
        setIsAuthenticated(true);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <form onSubmit={onSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}

        {successMessage && (
          <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
            {successMessage}
          </div>
        )}

        <input
          type="email"
          placeholder="Email"
          name="email"
          value={email}
          onChange={onChange}
          required
          className="w-full p-3 mb-4 border rounded"
        />
        
        <input
          type="password"
          placeholder="Password"
          name="password"
          value={password}
          onChange={onChange}
          required
          className="w-full p-3 mb-6 border rounded"
        />

        <div className="flex flex-col space-y-4">
          <button 
            type="submit" 
            className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700 transition"
          >
            Login
          </button>

          <div className="flex justify-between items-center">
            <Link 
              to="/register" 
              className="text-blue-600 hover:underline"
            >
              Register here
            </Link>
            
            <Link 
              to="/forgot-password" 
              className="text-blue-600 hover:underline"
            >
              Forgot Password?
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Login;